import { useMemo } from "react";
import { TranslationService } from "../../services/TranslationService";
import CompanyService, { Entities } from "../../services/CompanyService";
import { EntityField } from "../../pages/shared/entities/EntityField";
import { DropdownItems } from "../../pages/shared/components/Dropdown";
import { addIf } from "../../utils/Utils";

interface UseInsertFieldOptionsProps {
  includeInvoices: boolean;
}

export const useInsertFieldOptions = ({
  includeInvoices
}: UseInsertFieldOptionsProps) => {
  const data = useMemo(() => {
    const clientFieldsMap = [
      TranslationService.translate.Client,
      TranslationService.translate.Contact,
      TranslationService.translate.Comments,
      TranslationService.translate.FollowUpMail,
      ...CompanyService.getAdditionalDefinitionsFiltered(Entities.Client)
        .map((x) => new EntityField(x))
        .map((x) => x.title)
    ].map((x, index) => ({
      text: x!,
      value: `[${x!}]`,
      key: `client-${index}-${x!}`
    }));

    if (
      CompanyService.getCompanyAuthorization().includes("customerportalenabled")
    ) {
      clientFieldsMap.push({
        text: TranslationService.translate.CustomerSite,
        value: "[Portal]",
        key: "client-portal"
      });
    }

    const invoiceFieldsMap = [
      TranslationService.translate.Amount,
      TranslationService.translate.DueAmount,
      TranslationService.translate.NotDueAmount,
      TranslationService.translate.Date
    ].map((x, index) => ({
      text: x!,
      value: `[${x!}]`,
      key: `invoice-${index}-${x!}`
    }));

    const fields: DropdownItems<string> = [
      {
        isTitle: true,
        text: TranslationService.translate.FilterData.replace(
          "{EntityName}",
          TranslationService.translate.Invoice
        ),
        key: "title-invoice"
      },
      ...invoiceFieldsMap,
      ...addIf(includeInvoices, {
        text: TranslationService.translate.InvoiceList,
        value: `[${TranslationService.translate.Invoices}]`,
        key: "invoice-list"
      }),
      {
        isTitle: true,
        text: TranslationService.translate.FilterData.replace(
          "{EntityName}",
          TranslationService.translate.Client
        ),
        key: "title-client"
      },
      ...clientFieldsMap
    ];
    return fields;
  }, [includeInvoices]);

  return {
    data,
    isLoading: false
  };
};
